var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelPagesCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 192,
    viewBox: "0 0 128 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 192,
    fill: "#E0EEFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 104,
    y: 0.5,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E0EEFF",
    strokeLinecap: "round",
    d: "M32.5 24.5L32.5 104.5M14.5 24.5L14.5 104.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E0EEFF",
    strokeLinecap: "round",
    d: "M56 -15L56 97",
    transform: "rotate(-90 56 41)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E0EEFF",
    strokeLinecap: "round",
    d: "M56 1L56 113",
    transform: "rotate(-90 56 57)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E0EEFF",
    strokeLinecap: "round",
    d: "M56 17L56 129",
    transform: "rotate(-90 56 73)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E0EEFF",
    strokeLinecap: "round",
    d: "M56 33L56 145",
    transform: "rotate(-90 56 89)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E0EEFF",
    strokeLinecap: "round",
    d: "M48.5 24.5L48.5 104.5M64.5 24.5L64.5 104.5M80.5 24.5L80.5 104.5M96.5 24.5L96.5 104.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338EFF",
    d: "M2 .5h108c1.105 0 2 .895 2 2v22H0v-22c0-1.105.895-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0072FF",
    d: "M32 56.5H48V72.5H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9FF",
    d: "M0 24.5H16V40.5H0zM16 24.5H32V40.5H16zM64 88.5H80V104.5H64zM80 88.5H96V104.5H80zM96 88.5h16v14c0 1.105-.895 2-2 2H96v-16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEFF",
    d: "M4 0h120c2.21 0 4 1.79 4 4v12H0V4c0-2.21 1.79-4 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 8,
    r: 3,
    fill: "#25CF1B"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99C7FF",
    d: "M0 16.5L128 16.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    fill: "#F20D5D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 3,
    fill: "#F9C206"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    x: 36,
    y: 4,
    fill: "#FFF",
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 23c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zm5 0c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zm0-4c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zm-5 0c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zm7-12h-1V6c0-.552-.448-1-1-1s-1 .448-1 1v1h-8V6c0-.552-.448-1-1-1s-1 .448-1 1v1H9c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3V10c0-1.657-1.343-3-3-3zm1 17c0 .552-.448 1-1 1H9c-.552 0-1-.448-1-1v-9h16v9zm0-11H8v-3c0-.552.448-1 1-1h1v1c0 .552.448 1 1 1s1-.448 1-1V9h8v1c0 .552.448 1 1 1s1-.448 1-1V9h1c.552 0 1 .448 1 1v3zm-13 6c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zm0 4c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z",
    transform: "translate(8 8)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelPagesCalendar);
export default __webpack_public_path__ + "static/media/illustrations-funnel-pages-calendar.3862e0b5.svg";
export { ForwardRef as ReactComponent };